import { render, staticRenderFns } from "./HsabAccountSelection.vue?vue&type=template&id=54ad0cb6"
import script from "./HsabAccountSelection.vue?vue&type=script&lang=ts"
export * from "./HsabAccountSelection.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports